<template>
    <v-autocomplete
        ref="places"
        label="Address"
        id="places"
        v-model="addressModel"
        :items="locationEntries"
        :search-input.sync="locationSearchText"
        prepend-inner-icon="place"
        item-text="value"
        item-value="value"
        :error-messages="errors"
        hide-no-data
        outlined
        dense
        class="soli-round"
        validate-on-blur
        auto-select-first
        :rules="rules"
        @change="handleAddress"
    >
    </v-autocomplete>
</template>

<script>
import { GetPlacesAutocomplete } from "./../../Mixins/PlacesAPI";

export default {
    props: ["errors", "address", "city", "rules"],
    data: function () {
        return {
            GetPlacesAutocomplete: null,
            autocompleteLocationModel: null,
            locationSearchText: null,
            locationEntries: this.address
                ? [`${this.address}, ${this.city}`]
                : [],
            addressModel: this.address ? `${this.address}, ${this.city}` : null,
        };
    },
    methods: {
        handleAddress() {
            if (this.addressModel == null || this.addressModel == "null") {
                return;
            }
            this.$emit("setAddress", {
                address: this.addressModel.split(/, (.+)/)[0],
                city: this.addressModel.split(/, (.+)/)[1],
            });

            this.$refs.places.blur();
        },
    },
    watch: {
        locationSearchText(newVal) {
            if (newVal !== this.addressModel) {
                var _vue = this;

                // If less than 3 chars typed, do not search
                if (!newVal || newVal.length <= 2) return;

                // Call the method from the previous section here
                GetPlacesAutocomplete(newVal)
                    .then(function (res) {
                        _vue.locationEntries = res;
                    })
                    .catch(function (err) {
                        // error handling goes here
                    });
            }
        },
    },
    mounted() {
        this.$loadScript(
            "https://maps.googleapis.com/maps/api/js?key=AIzaSyAusPiHauq9IKpTzO7KC4-518Q_DtzG41I&libraries=places&callback=Function.prototype&loading=async"
        );
    },
};
</script>
